module.exports = __webpack_public_path__ + "media/images/dashboard-nav-hover-d646c0051b794ced5186e56ed82c4a97.svg";